function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "rv03a",
  d: "M1142.655 417.003l-.997.997-2.658-2.66.997-.997a1.177 1.177 0 0 1 1.662 0l.997.998a1.174 1.174 0 0 1 0 1.662zm-9.575 9.832L1129 428l1.166-4.08 7.92-7.92 2.914 2.914zm10.261-12.117l-1.06-1.06a2.252 2.252 0 0 0-3.18 0l-9.541 9.541a.496.496 0 0 0-.128.216l-1.413 4.948a.5.5 0 0 0 .618.618l4.948-1.414a.499.499 0 0 0 .216-.127l9.54-9.541c.426-.425.659-.99.659-1.59 0-.602-.233-1.166-.659-1.591z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-1128 -413)"
}, React.createElement("use", {
  xlinkHref: "#rv03a"
})));

var SvgPen = function SvgPen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pen.1168d730.svg";
export { ForwardRef as ReactComponent };